/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Download_Now_Using_CellularInputs */

const en_mobile_download_now_using_cellular = /** @type {(inputs: Mobile_Download_Now_Using_CellularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download now using cellular`)
};

const es_mobile_download_now_using_cellular = /** @type {(inputs: Mobile_Download_Now_Using_CellularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar ahora con datos móviles`)
};

/**
* | output |
* | --- |
* | "Download now using cellular" |
*
* @param {Mobile_Download_Now_Using_CellularInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_download_now_using_cellular = /** @type {((inputs?: Mobile_Download_Now_Using_CellularInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Download_Now_Using_CellularInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_download_now_using_cellular(inputs)
	return en_mobile_download_now_using_cellular(inputs)
});